const generateElementId = (prefix) => {
  const randomId = Math.random().toString(36).slice(2);
  return prefix ? `${prefix}${randomId}` : randomId;
};

export { generateElementId };
